/// <reference path="../wpt.ts" />
var WPTNamespace;
(function (WPTNamespace) {
    var DocActions;
    (function (DocActions) {
        const LOG_CATEGORY = "WPT.DocumentActions.Download";
        class DocActionDownload extends DocActions.DocActionBaseClass {
            constructor(core, name) {
                super(core, name);
                this._currentDocId = null;
                this._modalSession = null;
                this._documentDownloaded = (rawResponse) => {
                    this._log.info("DocActionDownload._documentDownloaded()");
                    if (this._modalSession) {
                        this._core.Helper.closeBusyModal(this._modalSession);
                        this._modalSession = null;
                    }
                    let objectURL = window.URL.createObjectURL(new Blob([rawResponse.ContentRaw]));
                    if (this._log.isTraceEnabled()) {
                        this._log.trace("created object URL: " + objectURL);
                    }
                    let tempAnchor = document.createElement('a');
                    tempAnchor.href = objectURL;
                    tempAnchor.download = rawResponse.ContentName;
                    document.body.appendChild(tempAnchor);
                    tempAnchor.click();
                    document.body.removeChild(tempAnchor);
                    window.URL.revokeObjectURL(objectURL);
                    this._currentDocId = null;
                };
                this._downloadError = () => {
                    this._log.info("DocActionDownload._downloadError()");
                    if (this._modalSession) {
                        this._core.Helper.closeBusyModal(this._modalSession);
                        this._modalSession = null;
                    }
                    let msg = this._core.Locale.getTranslation("STR_WPT_DOC_DOWNLOAD_FAILED_MSG") + ": " + this._currentDocId;
                    console.warn(msg);
                    this._core.Helper.presentWarningModal(msg);
                    this._currentDocId = null;
                };
                this._log = this._core.Logging.getLogger(LOG_CATEGORY);
                this._log.info("DocActionDownload::constructor");
                this._label = this._core.Locale.getTranslation("STR_WPT_DA_DOWNLOAD");
            }
            actionAllowed(request) {
                this._log.info("DocActionDownload.actionAllowed()");
                // haven't seen a privilege regarding download, so always allow download
                let result = true;
                if (request.hasOwnProperty('DocumentType') && request.DocumentType) {
                    if (request.DocumentType.Name in this._core.OBHelper.DownloadDocumentTypeMap) {
                        let docType = this._core.OBHelper.DownloadDocumentTypeMap[request.DocumentType.Name];
                        if (!docType.Privileges.Download)
                            return false;
                    }
                }
                if (request.PropertyBag != null) {
                    // don't allow download of Unity Forms
                    let fileTypeSetting = request.PropertyBag.find(setting => setting[0] === "FileType");
                    if (fileTypeSetting) {
                        if (this._log.isTraceEnabled()) {
                            this._log.trace("looking at file type: " + fileTypeSetting[1]);
                        }
                        result = fileTypeSetting[1] !== "Unity Form";
                    }
                }
                return result;
            }
            execute(request) {
                this._log.info("DocActionDownload.execute()");
                let modalSession = 'download-doc-' + performance.now();
                if (this._log.isTraceEnabled()) {
                    this._log.trace("created modal session: " + modalSession);
                }
                if (this._core.Helper.presentBusyModal(WPTNamespace.ModalType.FIRST, modalSession, "STR_WPT_PROCESSING")) {
                    this._modalSession = modalSession;
                }
                this._currentDocId = request.DocHandle;
                let url = '/OnBaseDocumentDownload.ashx?id=' + request.DocHandle;
                this._core.Loader.genericServiceCallRawData(url, this._documentDownloaded, this._downloadError);
            }
        }
        DocActions.DocActionDownload = DocActionDownload;
    })(DocActions = WPTNamespace.DocActions || (WPTNamespace.DocActions = {}));
})(WPTNamespace || (WPTNamespace = {}));
